// extracted by mini-css-extract-plugin
module.exports = {"homeGenreSlide":"HomeGenres_homeGenreSlide__01dh9","sectionHeading":"HomeGenres_sectionHeading__Eri4U","icon":"HomeGenres_icon__kbJz4"};